import React from 'react';
import { Play } from 'lucide-react';

const Showreel = () => {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-orange-500 font-semibold text-sm uppercase tracking-wider mb-3">
            Watch Our Story
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Brand Showreel
          </h2>
          <p className="text-xl text-slate-300">
            Experience our creative journey and see how we bring brands to life
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            {/* Video Player */}
            <video
              className="w-full h-auto"
              autoPlay
              loop
              muted
              playsInline
              controls
            >
              <source 
                src="https://customer-assets.emergentagent.com/job_e8e47bb8-4cbc-4606-b7c2-219274ab0c15/artifacts/t1bbav79_Mplify_showreel_4.mp4" 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
            
            {/* Play Icon Overlay (optional decorative element) */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent pointer-events-none flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
              <div className="w-20 h-20 bg-orange-600/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                <Play className="w-10 h-10 text-white ml-1" fill="white" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showreel;
